import { render } from "./notice.vue?vue&type=template&id=2130b2b2&scoped=true"
const script = {}

import "./notice.vue?vue&type=style&index=0&id=2130b2b2&scoped=true&lang=scss"

import exportComponent from "/Users/windy/work/vue/zhibo_am/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2130b2b2"]])

export default __exports__